/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MembershipDto } from './membership-dto';


export interface MembershipEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username
     */
    userName: string;
    /**
     * Event type
     */
    eventType: MembershipEventDto.EventTypeEnum;
    /**
     * Interaction ID
     */
    interactionId: string;
    /**
     * Membership ID
     */
    membershipId: string;
    /**
     * Type of membership event
     */
    membershipEventType: MembershipEventDto.MembershipEventTypeEnum;
    /**
     * Membership subject data
     */
    subject: MembershipDto;
    /**
     * Account ID associated with the event
     */
    accountId: string;
    /**
     * User ID who triggered or is related to the event
     */
    userId: string;
}
export namespace MembershipEventDto {
    export type EventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const EventTypeEnum = {
        UserChanged: 'USER_CHANGED' as EventTypeEnum,
        UserCreated: 'USER_CREATED' as EventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as EventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as EventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as EventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as EventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as EventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as EventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as EventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as EventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as EventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as EventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as EventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as EventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as EventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as EventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as EventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as EventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as EventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as EventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as EventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as EventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as EventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as EventTypeEnum
    };
    export type MembershipEventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const MembershipEventTypeEnum = {
        UserChanged: 'USER_CHANGED' as MembershipEventTypeEnum,
        UserCreated: 'USER_CREATED' as MembershipEventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as MembershipEventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as MembershipEventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as MembershipEventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as MembershipEventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as MembershipEventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as MembershipEventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as MembershipEventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as MembershipEventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as MembershipEventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as MembershipEventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as MembershipEventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as MembershipEventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as MembershipEventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as MembershipEventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as MembershipEventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as MembershipEventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as MembershipEventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as MembershipEventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as MembershipEventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as MembershipEventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as MembershipEventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as MembershipEventTypeEnum
    };
}


